import * as React from "react";
const SvgPublished = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 5H13V13.5H3V5Z", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 2.5H11L13 5H3L5 2.5Z", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 11.75V6.75", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6 8.75L8 6.75L10 8.75", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgPublished;
